/**
 * @file
 */

import { autoHeightAnimate } from './heightAnimation.js'

export default (Drupal, once) => {

  Drupal.behaviors.pieChart = {
    attach (context) {
      once('dcn-piechart', '.paragraph--type--pie-chat', context).forEach(function (pieChart) {
        const accordionContent = '.field--name-field-accordion-group'
        const animateTime = 200

        pieChart.querySelectorAll('svg path').forEach(function (path) {
          path.addEventListener('click', function () {
            const pieLabel = path.getAttribute('data-label')
            const accordionElement = Array.from(document.querySelectorAll('.paragraph--type--accordion-item')).find(function (item) {
              return item.getAttribute('data-accordion') === pieLabel
            })

            if (!accordionElement) {
              return
            }

            const accordionGroup = accordionElement.querySelector(accordionContent)

            window.scrollTo({
              top: accordionElement.getBoundingClientRect().top + window.scrollY,
              behavior: 'smooth'
            })

            if (!accordionElement.classList.contains('accordion-open')) {
              accordionElement.classList.add('accordion-open', 'fade-in')
              accordionElement.setAttribute('aria-expanded', 'true')

              if (accordionGroup) {
                autoHeightAnimate(accordionGroup, animateTime)
              }

              setTimeout(function () {
                accordionElement.classList.add('accordion-open')
                accordionElement.classList.remove('fade-in')
              }, 100)
            }
          })
        })
      })
    }
  }
}
